export const PAGINATION_LIMIT = 10
export const SUPPORT_DASHBOARD_PAGINATION_LIMIT = 200
export const BACKEND_SUPPORTED_PAGINATION_LIMIT = 500
export const LOGIN_COUNT_KEY = 'https://thriveworks.com/loginCount'
export const USER_TYPE_KEY = 'https://thriveworks.com/createdBy' //'self' || 'support' || 'amd'
export const USER_PROVIDERS = 'https://thriveworks.com/providers' // tells which sources it was logged in from eg; auth0, google-oauth2
export const USER_PROVIDER_TYPE = {
  AUTH0: 'auth0',
  GOOGLE: 'google-oauth2',
}
export enum ResponseErrorCode {
  SLOT_ALREADY_BOOKED = '3001',
  MEDICATION_SLOT_LIMIT = '3002',
  NO_OPEN_SLOT = '3003',
}

export const CANCELED_API_ERROR = 'Canceled'
